const CONTENT_ELEMENTS = ['address', 'article', 'aside', 'code', 'div', 'em', 'p', 'pre', 'section', 'small', 'span', 'strong'];

export { CONTENT_ELEMENTS };
